namespace TabAurous.OMS {
    export interface UserDetailsRow {
        UserdetailsId?: number;
        UserId?: number;
        CompanyId?: number;
        DepartmentId?: number;
        RackId?: number;
        Username?: string;
    }

    export namespace UserDetailsRow {
        export const idProperty = 'UserdetailsId';
        export const localTextPrefix = 'OMS.UserDetails';
        export const lookupKey = 'OMS.UserDetails';

        export function getLookup(): Q.Lookup<UserDetailsRow> {
            return Q.getLookup<UserDetailsRow>('OMS.UserDetails');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            UserdetailsId = "UserdetailsId",
            UserId = "UserId",
            CompanyId = "CompanyId",
            DepartmentId = "DepartmentId",
            RackId = "RackId",
            Username = "Username"
        }
    }
}
